const sessionVuexModule = {
  state: {
    currentUser: undefined,
    userId: undefined,
    isAdmin: false
  },

  mutations: {
    setCurrentUser (state, user) { state.currentUser = user; },
    setUserId (state, id) { state.userId = id; },
    setAdmin (state, isAdmin) { state.isAdmin = isAdmin; }
  },

  getters: {
    currentUser: state => state.currentUser,
    userId: state => state.userId,
    isAdmin: state => state.isAdmin
  }
};

export default sessionVuexModule;
